query ContentsList($page: Int, $rowsPerPage: Int, $filter: ContentsFilterInput) {
  contents(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      type
      title
      premium
      collectionIds
      productIds
      processingStatus
      transcodingError
      duration
      publishAt
      hideInGeneralLists
      onlyUsers
      url
      preview {
        id
        url(format: SMALL)
      }
      playback {
        thumbnailUrl
      }
      totalViews
      viewersOnline
      tags {
        id
        title
      }
      createdAt
      updatedAt
    }
  }
}
